import React from "react";
import SEO from "@/components/SEO";
import { ExternalLink } from "lucide-react";

const RESOURCES = [
  { name: "City of Casper — Utilities", url: "https://www.casperwy.gov/residents/utilities", desc: "Set up or transfer water, sewer, and trash service with the City of Casper." },
  { name: "WYDOT — Wyoming Road Conditions", url: "https://www.wyoroad.info/", desc: "Official Wyoming Department of Transportation road status, closures, and weather advisories. Check the day before every winter move." },
  { name: "USPS — Change of Address", url: "https://moversguide.usps.com/", desc: "Official USPS Movers Guide to file your change of address online (small verification fee applies)." },
  { name: "Casper Area Chamber of Commerce", url: "https://www.casperwyoming.org/", desc: "Local business directory, community events, and relocation resources for the Casper area." },
  { name: "Wyoming SBDC", url: "https://www.wyomingsbdc.org/", desc: "Free consulting and resources for Wyoming small businesses — helpful when relocating a business." },
  { name: "Natrona County School District", url: "https://www.natronaschools.org/", desc: "School enrollment and boundary information for families moving into Casper, Mills, Evansville, and Bar Nunn." },
  { name: "Wyoming DOT — Driver License Change", url: "https://www.dot.state.wy.us/wyoming-driver-services/", desc: "Change your Wyoming driver license address online or in person after moving." },
];

const ResourcesPage = () => (
  <>
    <SEO title="Casper Moving Resources | Local Utilities & Official Links | Crosstown Movers"
      description="Curated official local resources for a Casper move — utilities, road conditions, USPS change of address, schools, and Chamber of Commerce."
      path="/casper-moving-resources" />
    <section className="py-16 md:py-20 bg-[var(--ct-primary)] text-white">
      <div className="section-container">
        <div className="label-xs text-white mb-3">Free Resource</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>Casper Moving Resources</h1>
        <p className="mt-4 text-white/85 max-w-3xl text-lg">Official local links every Casper newcomer needs. We're not affiliated with any of these organizations — they're just the resources we point families to.</p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="section-container max-w-3xl space-y-4">
        {RESOURCES.map((r, i) => (
          <a key={i} href={r.url} target="_blank" rel="noopener nofollow"
             className="block p-6 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] hover:border-[var(--ct-primary)] transition"
             data-testid={`resource-${i}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <h2 className="text-xl font-semibold text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>{r.name}</h2>
                <p className="mt-2 text-[var(--ct-text-muted)]">{r.desc}</p>
                <div className="mt-3 text-sm text-[var(--ct-secondary)] break-all">{r.url}</div>
              </div>
              <ExternalLink className="w-5 h-5 text-[var(--ct-primary)] flex-shrink-0 mt-1" />
            </div>
          </a>
        ))}
        <p className="text-xs text-[var(--ct-text-muted)] pt-6">Crosstown Movers is not affiliated with these organizations. Links are provided as convenience for Casper-area residents; verify current details on each official website.</p>
      </div>
    </section>
  </>
);

export default ResourcesPage;
